const Report = () =>
  import(
    /* webpackChunkName: "order-template" */ '@/pages/order/template/index.vue'
  )
const Detail = () =>
  import(
    /* webpackChunkName: "order-template" */ '@/pages/order/template/detail.vue'
  )

export default {
  path: 'template',
  meta: {
    label: 'ShipmentTemplate',
    auth: 'template'
  },
  component: {
    name: 'Template',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'OrderTemplateReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Report
    },
    {
      name: 'OrderTemplateDetail',
      path: ':id',
      meta: {
        label: 'detail',
        auth: 'detail'
      },
      component: Detail,
      props: true
    }
  ]
}
